// Single source of truth for the Biological Process (GO BP) terms used both
// by the BP filter bar chart and the in-grid filtering logic. Update here to
// change the set everywhere it is referenced.
const BP_GO_TERMS = [
  { id: 'GO:0006887', label: 'Exocytosis' },
  { id: 'GO:0016192', label: 'Vesicle-mediated transport' },
  { id: 'GO:0032940', label: 'Secretion by cell' },
  { id: 'GO:0003330', label: 'Regulation of extracellular matrix constituent secretion' },
  { id: 'GO:2000257', label: 'Regulation of protein activation cascade' },
  { id: 'GO:0030449', label: 'Regulation of complement activation' },
  { id: 'GO:0006957', label: 'Complement activation, alternative pathway' },
  { id: 'GO:0006958', label: 'Complement activation, classical pathway' },
  { id: 'GO:0002920', label: 'Regulation of humoral immune response' },
  { id: 'GO:0045087', label: 'Innate immune response' },
  { id: 'GO:0042730', label: 'Fibrinolysis' },
  { id: 'GO:0050819', label: 'Negative regulation of coagulation' },
  { id: 'GO:0050818', label: 'Regulation of coagulation' },
  { id: 'GO:1900046', label: 'Regulation of hemostasis' },
  { id: 'GO:0006953', label: 'Acute-phase response' },
  { id: 'GO:0002526', label: 'Acute inflammatory response' },
  { id: 'GO:0032101', label: 'Regulation of response to external stimulus' },
  { id: 'GO:0006952', label: 'Defense response' },
];

export default BP_GO_TERMS;
export { BP_GO_TERMS };
